
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6.257 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1378 -300)","fill":"#adadad"}},[_c('circle',{attrs:{"data-name":"Ellipse 3","cx":"3.128","cy":"3.128","r":"3.128","transform":"translate(1378 323.743)"}}),_c('circle',{attrs:{"data-name":"Ellipse 2","cx":"3.128","cy":"3.128","r":"3.128","transform":"translate(1378 311.872)"}}),_c('circle',{attrs:{"data-name":"Ellipse 1","cx":"3.128","cy":"3.128","r":"3.128","transform":"translate(1378 300)"}})])])
          )
        }
      }
    